<form [formGroup]="qModelForm" (submit)="onSubmit()">
  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Id</mat-label>
    <input matInput type="text" formControlName="id" [matAutocomplete]="auto" />
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option *ngIf="isLoading"><mat-spinner diameter="20"></mat-spinner></mat-option>
      <ng-container *ngIf="!isLoading">
        <mat-option *ngFor="let id of qModelIds" [value]="id">
          {{ id }}
        </mat-option>
      </ng-container>
    </mat-autocomplete>
    <mat-hint>Id of the .qmd file</mat-hint>
  </mat-form-field>
  <div formArrayName="parameters" class="cf-flex-column">
    <span>Parameters</span>
    <div *ngFor="let group of parameters.controls; let i = index; last as isLast">
      <div [formGroupName]="i" class="cf-flex-row cf-gap-10 cf-fill cf-justify-content-center cf-align-items-center">
        <mat-form-field appearance="fill" class="flex-48-percent">
          <mat-label>Key</mat-label>
          <input matInput placeholder="key" formControlName="key" (blur)="parameterBlur()" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-48-percent">
          <mat-label>Value</mat-label>
          <input matInput placeholder="value" formControlName="value" (blur)="parameterBlur()" />
        </mat-form-field>
        <span [style.visibility]="isLast ? 'hidden' : 'visible'" class="clear-btn" (click)="removeParameter(i)">
          <mat-icon aria-hidden="false" aria-label="Remove QModel parameter">clear</mat-icon>
        </span>
      </div>
    </div>
  </div>
  <div formArrayName="tags" class="cf-flex-column">
    <span>Tags</span>
    <div *ngFor="let group of tags.controls; let i = index; last as isLast">
      <div [formGroupName]="i" class="cf-flex-row cf-gap-10 cf-fill cf-justify-content-center cf-align-items-center">
        <mat-form-field appearance="fill" class="flex-48-percent">
          <mat-label>Key</mat-label>
          <input matInput placeholder="key" formControlName="key" (blur)="tagBlur()" />
        </mat-form-field>
        <mat-form-field appearance="fill" class="flex-48-percent">
          <mat-label>Value</mat-label>
          <input matInput placeholder="value" formControlName="value" (blur)="tagBlur()" />
        </mat-form-field>
        <span [style.visibility]="isLast ? 'hidden' : 'visible'" class="clear-btn" (click)="removeTag(i)">
          <mat-icon aria-hidden="false" aria-label="Remove QModel tag">clear</mat-icon>
        </span>
      </div>
    </div>
  </div>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Detail mode</mat-label>
    <mat-select formControlName="detailMode">
      <mat-option [value]="0">Unknown</mat-option>
      <mat-option [value]="1">CAT</mat-option>
      <mat-option [value]="2">LOD</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>LOD level</mat-label>
    <mat-select formControlName="lodLevel">
      <mat-option [value]="0">Unknown</mat-option>
      <mat-option [value]="1">LOD 200</mat-option>
      <mat-option [value]="2">LOD 300</mat-option>
      <mat-option [value]="4">LOD 350</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Platform</mat-label>
    <mat-select formControlName="platform">
      <mat-option [value]="0">Unknown</mat-option>
      <mat-option [value]="1">Preview</mat-option>
      <mat-option [value]="2">AutoCAD</mat-option>
      <mat-option [value]="4">Revit</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>View mode</mat-label>
    <mat-select formControlName="viewMode">
      <mat-option [value]="0">Solid</mat-option>
      <mat-option [value]="1">WireFrame</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Dimension line mode</mat-label>
    <mat-select formControlName="dimensionLineMode">
      <mat-option [value]="0">Off</mat-option>
      <mat-option [value]="1">Values</mat-option>
      <mat-option [value]="2">Labels</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="cf-fill">
    <mat-label>Calculation resolution</mat-label>
    <mat-select formControlName="calculationResolution">
      <mat-option [value]="0">Low</mat-option>
      <mat-option [value]="1">Medium</mat-option>
      <mat-option [value]="2">High</mat-option>
    </mat-select>
  </mat-form-field>

  <button style="display: none" type="submit"></button>
</form>
